module.exports = __webpack_public_path__ + "img/17871_L.d4423c06.png";